// import { useParams } from "react-router-dom";
// import "./index.css";
// import { useEffect, useState } from "react";
// import VideoPlayer from "../VideoPlayer/videoplayer";

// const GoogleDocViewer = () => {
//   const { id } = useParams();
//   const [user] = useState(JSON.parse(localStorage.getItem("student")));
//   const [docData, setDocData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchSheet = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BASE_URL}/api/get-sheet-data`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ id, course: user.student.program }),
//           },
//         );

//         if (!response.ok) throw new Error("Failed to fetch document");

//         const result = await response.json();
//         setDocData(result.data);
//       } catch (e) {
//         console.error("Error fetching doc:", e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSheet();
//   }, [id]);

//   return (
//     <div className="doc-container">
//       <h1>Coding Practice Guidance Video</h1>
//       <VideoPlayer />

//       {loading && <p>Loading document…</p>}
//       {!loading && docData && (
//         <div className="doc-frame-container">
//           <h2>Session Resources</h2>
//           <iframe
//             src={`${docData}/preview`}
//             width="100% !important"
//             height="100%"
//             title="Google Document Viewer"
//             allowFullScreen
//           ></iframe>{" "}
//         </div>
//       )}
//       {!loading && !docData && <p>Document not found</p>}
//     </div>
//   );
// };

// export default GoogleDocViewer;

// New code for codesol
import { useParams } from "react-router-dom";
import "./index.css";
import { useEffect, useState } from "react";
import VideoPlayer from "../VideoPlayer/videoplayer";

const GoogleDocViewer = () => {
  const { id } = useParams();

  const [user] = useState(JSON.parse(localStorage.getItem("student")));

  const [docData, setDocData] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState("cheatSheet");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSheet = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/get-sheet-data`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id,
              course: user.student.program,
            }),
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch document");
        }

        const result = await response.json();

        console.log("DOCUMENT DATA:", result.data);

        setDocData(result.data);
      } catch (e) {
        console.error("Error fetching doc:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchSheet();
  }, [id, user]);

  const hasCheatSheet = docData?.cheatSheet && docData.cheatSheet !== "NA";

  const hasCodeSolution = docData?.codeSol && docData.codeSol !== "NA";

  return (
    <div className="doc-container">
      <h1>Coding Practice Guidance Video</h1>

      {/* Project Explanation Video */}
      <VideoPlayer />

      {loading && <p>Loading documents...</p>}

      {!loading && docData && (
        <div className="doc-frame-container">
          <h2>Session Resources</h2>

          {/* Document Buttons */}
          <div className="document-buttons">
            {hasCheatSheet && (
              <button
                className={
                  selectedDoc === "cheatSheet" ? "doc-btn active" : "doc-btn"
                }
                onClick={() => setSelectedDoc("cheatSheet")}
              >
                Cheat Sheet
              </button>
            )}

            {hasCodeSolution && (
              <button
                className={
                  selectedDoc === "codeSolution" ? "doc-btn active" : "doc-btn"
                }
                onClick={() => setSelectedDoc("codeSolution")}
              >
                Code Solution
              </button>
            )}
          </div>

          {/* Cheat Sheet */}
          {selectedDoc === "cheatSheet" && hasCheatSheet && (
            <iframe
              src={`${docData.cheatSheet}/preview`}
              width="100%"
              height="700px"
              title="Cheat Sheet"
              allowFullScreen
            />
          )}

          {/* Code Solution */}
          {selectedDoc === "codeSolution" && hasCodeSolution && (
            <iframe
              src={`${docData.codeSol}/preview`}
              width="100%"
              height="700px"
              title="Code Solution"
              allowFullScreen
            />
          )}
        </div>
      )}

      {!loading && !docData && <p>Documents not found</p>}
    </div>
  );
};

export default GoogleDocViewer;
